import {Component, Input} from '@angular/core';
import {UserService} from '../../../../../../@core/services/user.service';
import {FamilyService} from '../../../../../../@shared/services/family-service';
import {AQH_FAM_1, AQH_FAM_2} from '../../../../../../@shared/models/input.module';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {ToastService} from '../../../../../../@core/services/toast.service';

export interface tempUser {
  firstName: string;
  lastName: string;
  riding_club: string;
  date_of_birth: string;
}
@Component({
  selector: 'app-add-membership',
  standalone: false,
  templateUrl: './add-membership.html',
  styleUrl: './add-membership.css'
})
export class AddMembership {
  @Input() familyId: number
  addChildAccount: boolean = false
  email: string = '';
  tempUser: tempUser
  tempUserProfileImage: File | null = null;

  constructor(private userService: UserService,
              private familyService: FamilyService,
              private modal: NgbActiveModal,
              private toastService: ToastService) {
    this.tempUser = {
      firstName: '',
      lastName: '',
      riding_club: '',
      date_of_birth: ''
    }
  }

  ngOnInit() {}


  addUserByEmail() {
    //validate email

    let params: AQH_FAM_1 = {
      family_id: this.familyId,
      email: this.email
    }
    this.familyService.addFamilyMemberByEmail(params).subscribe((res) => {
      if (res) {
        this.modal.close(true)
      }
    })
  }

  addUserWithoutAccount() {
    // Validate required fields
    if (!this.tempUser.firstName || !this.tempUser.lastName) {
      this.toastService.error('First name and last name are required');
      return;
    }

    const params: AQH_FAM_2 = {
      family_id: this.familyId,
      first_name: this.tempUser.firstName,
      last_name: this.tempUser.lastName,
      date_of_birth: this.tempUser.date_of_birth,
      riding_club: this.tempUser.riding_club
    };

    this.familyService.addChildMember(params).subscribe({
      next: (res) => {
        if (res) {
          this.toastService.success('Child added successfully');
          this.modal.close(true);
        }
      },
      error: (error) => {
        console.error('Error adding child:', error);
        this.toastService.error('Failed to add child');
      }
    });
  }

}
